/** maximum announcement draftss that creators can create in the interval of 30 days */
export const ANNOUNCEMENT_DRAFT_LIMIT = Object.freeze({
    INTERVAL_DAYS: 30,
    MAX_NUMBER: 20,
});
/** number of days announcement will be live on the collection page */
export const DEFAUL_LIVE_DAYS = 1;
export const MAX_TITLE_CHARS = 90;
export const MAX_CONTENT_CHARS = 700;
